<template>
    <div :class="[$style.send__file]" v-if="fileData.length > 0">
        <ul :class="[$style.send__file__list]">
            <li v-for="(item, id) in fileData" v-bind:key="id">
                <div  :class="[$style.send__file_style]" >
                    <span :class="[$style.__attach__box]">
                        <i class="material-icons">attach_file</i>
                    </span> 
                    <span  :class="[$style.__url]">{{item.object.name.slice(0, 20) + (item.object.name.length > 20 ? "..." : "")}}</span>
                    <span :class="[$style.___close]"  @click="callCloseHandle">
                        <i class="material-icons">close</i>
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        fileData: {
            type : Array,
        },
    },
    methods : {
        handleRemoveImage : function (event) {
            this.$emit('parentRemoveImage', event)
        },

        callCloseHandle : function (event) {
            this.$emit('parentCallRemoveFile', true)

        }
    }
}
</script>
<style lang="scss" module scoped>
   .send__file  {
       .send__file__list {
            margin-bottom: 20px !important;
            padding-left: 0;
            li {
                list-style-type: none;
            }
            .__attach__box {
                background: #19ABFF;
                display: inline-block;
                padding: 5px;
                height: 100%;
                color: #fff;
                margin-right: 10px;
                -webkit-touch-callout: none; /* iOS Safari */
                -webkit-user-select: none; /* Safari */
                -khtml-user-select: none; /* Konqueror HTML */
                -moz-user-select: none; /* Old versions of Firefox */
                    -ms-user-select: none; /* Internet Explorer/Edge */
                        user-select: none; /* Non-prefixed version, currently
                                            supported by Chrome, Opera and Firefox */
                i {
                    font-size: 19px !important;
                    transform: rotate(90deg);
                }
            }
            .send__file_style {
                border: 1px solid #19ABFF;
                padding: 0px 0px;
                width: 100%;
                height: 28px;
                display: table;
                -webkit-border-radius: 6px;
                -moz-border-radius: 6px;
                border-radius: 6px;
                overflow: hidden;
                .__url {
                    font-size: 13px;
                    position: relative;
                    top: -5px;
                    color: #333;
                }
                .___close {
                    cursor: pointer;
                    color: #19ABFF;
                    float: right;
                    height: 100%;
                    margin-right: 5px;
                    i {
                        font-size: 14px;
                        position: relative;
                        top: 25%;
                        -webkit-touch-callout: none; /* iOS Safari */
                        -webkit-user-select: none; /* Safari */
                        -khtml-user-select: none; /* Konqueror HTML */
                        -moz-user-select: none; /* Old versions of Firefox */
                            -ms-user-select: none; /* Internet Explorer/Edge */
                                user-select: none; /* Non-prefixed version, currently
                                                    supported by Chrome, Opera and Firefox */
                    }
                }
            }
       }
    }
</style>